import { api } from './sessao';

/**
 * Baixa um documento e dispara o "salvar como" do navegador.
 *
 * O `revokeObjectURL` não é zelo: sem ele, cada download prende o arquivo
 * inteiro na memória da aba até o reload. Um contador que gere quarenta
 * contratos numa sessão sente — e o sintoma que ele relata é "o sistema fica
 * lento", que é o mais difícil de diagnosticar depois.
 *
 * Adiado um tick: revogar antes de o navegador iniciar o download cancela o
 * próprio download em alguns navegadores.
 */
export async function baixarDocumento(id: string, nome: string): Promise<void> {
  const blob = await api.baixar(`/documentos/${id}`);
  const url = URL.createObjectURL(blob);
  try {
    const ancora = document.createElement('a');
    ancora.href = url;
    ancora.download = nome;
    document.body.appendChild(ancora);
    ancora.click();
    ancora.remove();
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 0);
  }
}
